import * as components from './components'

export default [
  {
    path: '/person/:uuid/home',
    component: components.PersonDetail,
    name: 'personDetail',
    props: true
  },
  {
    path: '/person/:uuid/edit',
    component: components.EditPerson,
    name: 'editPerson',
    props: true
  },
  {
    path: '/person/upload',
    component: components.PersonUpload,
    name: 'personUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/person/routes.js